
@if (_currentData) {
  <dhs-data-grid [data]="result" [fields]="fields" [config]="config" (configValues)="getConfigValues($event)" (onFilterChange)="onFilter($event)" [filterFieldGroup]="filterFields" (bindGrid)="bindDataToGrid($event)" (bulkActionClicked)="onBulkActionClicked($event)"></dhs-data-grid>
}